export const heHepTranslations = {
  hepPage: {
    languages: {
      en: 'אנגלית',
      he: 'עברית',
      ro: 'רומנית',
      ru: 'רוסית',
      es: 'ספרדית',
      uk: 'אוקראינית',
    },
    filterLabels: {
      equipment: 'ציוד',
      language: 'שפה',
      createdBy: 'נוצר על ידי',
    },
    createdByOptions: {
      onestep_content: 'תבניות OneStep',
      custom: 'תבניות מותאמות אישית',
      created_by_me: 'התבניות שלי',
    },
    history: {
      title: 'היסטוריה ומשוב',
      emptyStateTitle: 'עדיין לא נרשמו תרגילים',
      loadError: 'טעינת ההיסטוריה נכשלה',
      sets_one: 'סט אחד',
      sets_two: '{{count}} סטים',
      sets_other: '{{count}} סטים',
      reps_one: 'חזרה אחת',
      reps_two: '{{count}} חזרות',
      reps_other: '{{count}} חזרות',
      holdSec_one: 'החזקה של שנייה אחת',
      holdSec_two: 'החזקה של {{count}} שניות',
      holdSec_other: 'החזקה של {{count}} שניות',
      patientFeedback: 'משוב המטופל:',
      difficulty: 'רמת קושי:',
      easy: 'קל',
      medium: 'בינוני',
      hard: 'קשה',
      veryHard: 'קשה מאוד',
    },
    common: {
      instructions: 'הוראות',
      equipment: 'ציוד',
      categories: 'קטגוריות',
    },
    libraryPanel: {
      title: 'ספרייה',
      search: 'חיפוש',
      filters: 'מסננים',
      removeFilter: 'הסרת המסנן {{label}}',
      tabs: {
        templates: 'תבניות',
        exercises: 'תרגילים',
      },
      templates: {
        searchAriaLabel: 'חיפוש תבניות',
        loadError: 'טעינת התבניות נכשלה',
        exercises_one: 'תרגיל אחד',
        exercises_two: '{{count}} תרגילים',
        exercises_other: '{{count}} תרגילים',
        viewTemplate: 'הצגת תבנית',
        addTemplate: 'הוספת תבנית',
        custom: 'מותאמת אישית',
      },
      exercises: {
        searchAriaLabel: 'חיפוש תרגילים',
        loadError: 'טעינת התרגילים נכשלה',
        added: 'נוסף',
      },
      emptyState: {
        title: 'לא נמצאו תוצאות',
        description: 'אפשר לנסות מונח חיפוש אחר או לנקות את המסננים.',
      },
    },
    header: {
      activeExercises_one: 'תרגיל אחד',
      activeExercises_two: '{{count}} תרגילים',
      activeExercises_other: '{{count}} תרגילים',
      lastModified: 'עודכן לאחרונה: {{date}}',
      copyForEmr: 'העתקה לרשומה הרפואית',
      print: 'הדפסה',
      deleteAll: 'מחיקת כל התרגילים',
      saveAsTemplate: 'שמירה כתבנית חדשה',
      moreOptions: 'אפשרויות נוספות',
      language: 'שפה',
      deleteAllDialog: {
        title: 'מחיקת כל התרגילים',
        message: 'האם למחוק את כל התרגילים מהתוכנית? לא ניתן לבטל פעולה זו.',
        cancel: 'ביטול',
        confirm: 'מחיקת הכל',
      },
    },
    templateBuilder: {
      deleteTemplateDialog: {
        title: 'מחיקת תבנית',
        message:
          'האם למחוק את התבנית? היא תוסר מהתבניות המותאמות אישית של הארגון. לא ניתן לבטל פעולה זו.',
        cancel: 'ביטול',
        confirm: 'מחיקה',
      },
      saveAsTemplateModal: {
        title: 'שמירה כתבנית חדשה',
        language: 'שפה',
        selectLanguage: 'בחירת שפה',
        templateNamePlaceholder: 'שם התבנית',
        descriptionPlaceholder: 'הוספת תיאור',
        warningBanner: 'יצירת תבנית מוסיפה אותה לתבניות המשותפות של הארגון.',
        cancel: 'ביטול',
        createTemplate: 'יצירת תבנית',
        createSuccess: 'התבנית נוצרה בהצלחה',
      },
    },
    emrText: {
      programAssigned: 'הוקצתה למטופל תוכנית תרגילים ביתית.',
      programIncludes_one: 'התוכנית כוללת את התרגיל הבא:',
      programIncludes_two: 'התוכנית כוללת את {{count}} התרגילים הבאים:',
      programIncludes_other: 'התוכנית כוללת את {{count}} התרגילים הבאים:',
      sets_one: 'סט אחד',
      sets_two: '{{count}} סטים',
      sets_other: '{{count}} סטים',
      reps_one: 'חזרה אחת',
      reps_two: '{{count}} חזרות',
      reps_other: '{{count}} חזרות',
      untitledExercise: 'תרגיל',
      dosage: '{{sets}} × {{reps}}',
    },
    personalMessage: {
      addMessage: 'הוספת הודעה אישית',
      placeholder: 'הוספת הודעה אישית...',
      readMore: 'קרא עוד',
      readLess: 'קרא פחות',
    },
    exerciseList: {
      loadError: 'טעינת התרגילים נכשלה',
      emptyState: {
        title: 'יש לגרור תרגילים לכאן',
        subtitle: 'אפשר לבנות את התוכנית של {{name}} באמצעות גרירת תרגילים או תבניות מהספרייה',
        subtitleGeneric: 'אפשר לבנות את התוכנית באמצעות גרירת תרגילים או תבניות מהספרייה',
      },
    },
    errors: {
      removeExercise: 'הסרת התרגיל נכשלה',
      deleteAllExercises: 'מחיקת כל התרגילים נכשלה',
      reorderExercises: 'שינוי סדר התרגילים נכשל',
      addExercise: 'הוספת התרגיל נכשלה',
      addTemplate: 'הוספת התבנית נכשלה',
      updateExercise: 'עדכון התרגיל נכשל',
      updateMessage: 'שמירת ההודעה נכשלה',
      createTemplate: 'יצירת התבנית נכשלה',
      deleteTemplate: 'מחיקת התבנית נכשלה',
      previewExercise: 'טעינת התרגיל נכשלה',
    },
    exercisePreview: {
      description: 'תצוגה מקדימה של תרגיל',
      insertExercise: 'הוספת תרגיל',
      playVideo: 'הפעלת סרטון',
      tips: 'טיפים',
    },
    templatePreview: {
      description: 'תצוגה מקדימה של תבנית',
      descriptionLabel: 'תיאור:',
      exercisesLabel: 'תרגילים:',
      exercisesLoadError: 'טעינת התרגילים נכשלה',
      exercisesEmpty: 'אין תרגילים בתבנית זו',
      addExercises_one: 'הוספת תרגיל אחד',
      addExercises_two: 'הוספת {{count}} תרגילים',
      addExercises_other: 'הוספת {{count}} תרגילים',
      deleteTemplate: 'מחיקת תבנית',
    },
    exerciseCard: {
      viewExercise: 'הצגת תרגיל',
      editExercise: 'עריכת תרגיל',
      removeExercise: 'הסרת תרגיל',
      assignedAutomatically: 'שויך אוטומטית',
      automatedEditNote: 'עריכה תפסיק את העדכונים האוטומטיים של תרגיל זה.',
      weeklyCompletion: 'ביצוע שבועי {{performed}}/{{total}}',
      dailyCompletion: 'ביצוע יומי {{performed}}/{{total}}',
      sets_one: 'סט אחד',
      sets_two: '{{count}} סטים',
      sets_other: '{{count}} סטים',
      reps_one: 'חזרה אחת',
      reps_two: '{{count}} חזרות',
      reps_other: '{{count}} חזרות',
      holdSec_one: 'החזקה של שנייה אחת',
      holdSec_two: 'החזקה של {{count}} שניות',
      holdSec_other: 'החזקה של {{count}} שניות',
      removeConfirmTitle: 'מחיקת תרגיל',
      save: 'שמירה',
      cancel: 'ביטול',
      removeConfirmMessage: 'האם למחוק את התרגיל?',
      remove: 'מחיקה',
      fields: {
        sets: 'סטים',
        reps: 'חזרות',
        times: 'פעמים',
        sec: 'שנ׳',
      },
      frequency: {
        everyDay: 'כל יום',
        timesADay_one: 'פעם ביום',
        timesADay_two: 'פעמיים ביום',
        timesADay_other: '{{count}} פעמים ביום',
        timesAWeek_one: 'פעם בשבוע',
        timesAWeek_two: 'פעמיים בשבוע',
        timesAWeek_other: '{{count}} פעמים בשבוע',
      },
      frequencyUnits: {
        day: 'ליום',
        week: 'לשבוע',
      },
      frequencyUnitOptions: {
        day: 'יום',
        week: 'שבוע',
      },
      frequencyUnitsInline: {
        day: 'ביום',
        week: 'בשבוע',
      },
    },
  },
};
